import React, { useState, useEffect, Fragment } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import iconEmptyCall from '../img/iconEmptyCall.svg';
import Basurero from '../img/Basurero.svg';
import { connect } from 'react-redux';
import { compose } from 'redux';
import get from 'lodash/get';
import BarLoader from 'react-spinners/BarLoader';
import Spinner from '../../../../client/Spinner';
import { selectedPaymentPending, deleteselectedPaymentPending, paymentRequestAgent, recurringPaymentRequestAgent, getPaymentReceiptHistory, resetPaymentLoading, resetDomiciliationLoading } from '../../../../../redux/actions/agentActions';
import PaginationBar from '../paginationBar/PaginationBar';
import classNames from 'classnames';
import { isMobile } from 'react-device-detect';
import ChangePaymentMethodAction from '../changePaymentMethodAction';
import { useDomiciliationPermission } from '../../../../../hooks/useDomiciliationPermission';

const CustomCheckbox = withStyles({
  root: {
    color: '#2d6df6',
    '&$checked': {
      color: '#2d6df6'
    }
  },
  checked: {}
})(props => <Checkbox color="default" {...props} />);

const CustomTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#f5f5f5',
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    fontFamily: 'Sura Sans'
  },
  arrow: {
    color: '#f5f5f5'
  }
}))(Tooltip);

const styles = theme => ({
  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    border: 'none',
    width: isMobile ? '1200px' : '100%'
  },
  tableContainersMobile: {
    width: '100%',
    overflowX: 'scroll'
  },
  tableContainers: {
    width: '100%'
  },
  headerRow: {
    display: 'grid',
    gridTemplateColumns: '220px minmax(250px, 1fr) 120px 100px 100px 84px 60px 84px',
    backgroundColor: '#FFFFFF',
    width: '100%'
  },
  headerRowSummary: {
    display: 'grid',
    gridTemplateColumns: '220px minmax(250px, 1fr) 100px 80px 80px 84px 60px 84px 75px',
    backgroundColor: '#FFFFFF',
    width: '100%'
  },
  headerRowPending: {
    display: 'grid',
    gridTemplateColumns: '15% 18% 12% 12% 10% 9% 5% 9% 10%',
    backgroundColor: '#FFFFFF',
    width: '100%'
  },
  headerRowPendingNoDom: {
    display: 'grid',
    gridTemplateColumns: '18% 22% 14% 13% 11% 10% 6% 6%',
    backgroundColor: '#FFFFFF',
    width: '100%'
  },
  rowContainer: {
    backgroundColor: '#E5E9EA',
    padding: '0 5px 5px 5px',
    boxSizing: 'border-box',
    borderRadius: '10px'
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '220px minmax(250px, 1fr) 120px 100px 100px 84px 60px 84px',
    backgroundColor: '#FFFFFF',
    width: '100%',
    borderRadius: '5px'
  },
  rowSummary: {
    display: 'grid',
    gridTemplateColumns: '220px minmax(250px, 1fr) 100px 80px 80px 84px 60px 84px 75px',
    backgroundColor: '#FFFFFF',
    width: '100%',
    borderRadius: '5px'
  },
  rowExpanded: {
    display: 'grid',
    gridTemplateColumns: '220px minmax(250px, 1fr) 120px 100px 100px 84px 60px 84px',
    backgroundColor: '#FFFFFF',
    width: '100%',
    borderRadius: '5px 5px 0 0'
  },
  rowPending: {
    display: 'grid',
    gridTemplateColumns: '15% 18% 12% 12% 10% 9% 5% 9% 10%',
    backgroundColor: '#FFFFFF',
    width: '100%',
    borderRadius: '5px'
  },
  rowPendingExpanded: {
    display: 'grid',
    gridTemplateColumns: '15% 18% 12% 12% 10% 9% 5% 9% 10%',
    backgroundColor: '#FFFFFF',
    width: '100%',
    borderRadius: '5px 5px 0 0'
  },
  rowPendingNoDom: {
    display: 'grid',
    gridTemplateColumns: '18% 22% 14% 13% 11% 10% 6% 6%',
    backgroundColor: '#FFFFFF',
    width: '100%',
    borderRadius: '5px'
  },
  rowPendingExpandedNoDom: {
    display: 'grid',
    gridTemplateColumns: '18% 22% 14% 13% 11% 10% 6% 6%',
    backgroundColor: '#FFFFFF',
    width: '100%',
    borderRadius: '5px 5px 0 0'
  },
  headerRowMobile: {
    display: 'grid',
    gridTemplateColumns: '18% 18% 12% 12% 12% 10% 8% 10%',
    backgroundColor: '#FFFFFF',
    width: '100%',
    padding: '0 5px'
  },
  headerRowMobilePending: {
    display: 'grid',
    gridTemplateColumns: '15% 18% 12% 12% 10% 9% 5% 9% 10%',
    backgroundColor: '#FFFFFF',
    width: '100%',
    padding: '0 5px'
  },
  rowContainerMobile: {
    backgroundColor: '#E5E9EA',
    padding: '0 5px 5px 5px',
    boxSizing: 'border-box',
    width: '1070px'
  },
  rowMobile: {
    display: 'grid',
    gridTemplateColumns: '220px minmax(250px, 1fr) 120px 100px 100px 84px 60px 84px',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    width: '100%'
  },
  rowMobilePending: {
    display: 'grid',
    gridTemplateColumns: '15% 18% 12% 12% 10% 9% 5% 9% 10%',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    width: '100%'
  },
  expandedRowPending: {
    display: 'grid',
    alignItems: 'start',
    gridTemplateColumns: '7% 8% 18% 12% 12% 24% 9% 5% 5%',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    width: '100%'
  },
  rowSummaryMobile: {
    display: 'grid',
    gridTemplateColumns: '15% 18% 12% 12% 10% 9% 5% 9% 10%',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    width: '100%'
  },
  cell: {
    padding: '4px',
    display: 'flex',
    fontFamily: 'Sura Sans',
    alignItems: 'center'
  },
  cellMobile: {
    padding: '4px 2%',
    display: 'flex',
    fontFamily: 'Sura Sans',
    alignItems: 'center',
    position: 'absolute',
    right: '0',
    height: '56px',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px'
  },
  cellHead: {
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    color: '#888B8D',
    fontFamily: 'Sura Sans'
  },
  cellHeadMobile: {
    position: 'absolute',
    right: '0',
    height: '56px',
    padding: '4px 4%',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    color: '#888B8D',
    fontFamily: 'Sura Sans'
  },
  expandedRow: {
    backgroundColor: '#FFFFFF',
    gridColumn: '1 / -1'
  },
  textPolicy: {
    color: '#0033A0'
  },
  textHead: {
    color: '#888B8D',
    fontSize: '12px',
    fontFamily: 'Sura Sans'
  },
  textBold: {
    color: '#000000',
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: 'Sura Sans'
  },
  paddingHead: {
    padding: 0
  },
  errorRow: {
    border: '1px solid red',
    borderRadius: '10px'
  },
  errorMessage: {
    color: 'red',
    margin: '5px 0 0 15px',
    fontSize: '12px',
    fontFamily: 'Sura Sans',
    fontWeight: 400
  },
  btnSecondary: {
    backgroundColor: '#FFF',
    color: '#00AEC7',
    borderRadius: '14px',
    padding: '6px 23px 5px',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '14px',
    border: '1px solid #00AEC7',
    transition: 'all 0.5s ease-out',
    '&:hover': {
      backgroundColor: '#00AEC7',
      color: '#fff',
    }
  },
  btnAqua: {
    backgroundColor: '#00B2A9',
    color: '#FFFFFF',
    borderRadius: '14px',
    padding: '6px 16px 5px',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '14px',
    transition: 'all 0.5s ease-out',
    '&:hover': {
      backgroundColor: '#008295',
    }
  },
  menuButton: {
    marginLeft: '8px',
    padding: 0,
    height: '14px !important',
    width: '14px !important',
  },
  statusText: {
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: 'Sura Sans'
  },
  statusError: {
    color: '#D12D35'
  },
  statusSuccess: {
    color: '#067014'
  },
  detailButton: {
    background: 'none',
    border: 'none',
    color: '#2D6DF6',
    fontWeight: 600,
    fontSize: '14px',
    fontFamily: 'Sura Sans',
    cursor: 'pointer',
    padding: 0,
    textAlign: 'left'
  },
  domiciliationToast: {
    minWidth: '800px',
    backgroundColor: '#F4C7C7',
    color: 'red',
    textAlign: 'center',
    borderRadius: '10px',
    padding: '16px',
    position: 'fixed',
    zIndex: 1000,
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: '60px',
    fontSize: '17px',
    border: '1px solid red'
  }
});

const groupByBankReference = rows => {
  const grouped = rows.reduce((acc, row) => {
    const bankReference = row.bank_reference || 'no_reference';
    if (!acc[bankReference]) {
      acc[bankReference] = [];
    }
    acc[bankReference].push(row);
    return acc;
  }, {});
  return grouped;
};

const GenericTable = ({
  classes,
  columns,
  rows,
  withCheckbox,
  onSelect,
  onExpand,
  onRowClick,
  selectedRows,
  page,
  rowsPerPage,
  onPageChange,
  totalSum,
  isPending,
  withActions,
  selectedPaymentPending,
  selectedData,
  currentRecordsPending,
  totalRecordsPending,
  totalPagesPending,
  getDataTable,
  agentId,
  paymentToken,
  currentPage,
  type,
  isLoading,
  deleteselectedPaymentPending,
  paymentRequestAgent,
  recurringPaymentRequestAgent,
  resetPaymentLoading,
  resetDomiciliationLoading,
  setIsLoading,
  currency,
  setOrderParams,
  orderParams,
  metadata,
  selectedReferences,
  isFilter,
  getPaymentReceiptHistory,
  setShowCancellationMessage,
  errorPaymentRequest,
  errorDomiciliationRequest
}) => {
  // Check domiciliation permissions using the token from Redux
  const { canView: canViewDomiciliation } = useDomiciliationPermission(paymentToken);

  const [expandedRows, setExpandedRows] = useState({});
  const [selectedTotals, setSelectedTotals] = useState(() => {
    if (window.location.pathname === '/cobranza/agente') {
      return [];
    }
    const savedTotals = localStorage.getItem('selectedTotals');
    return savedTotals ? JSON.parse(savedTotals) : [];
  });
  const [selectedTotalsmn, setSelectedTotalsmn] = useState(() => {
    if (window.location.pathname === '/cobranza/agente') {
      return [];
    }
    const savedTotalsmn = localStorage.getItem('selectedTotalsmn');
    return savedTotalsmn ? JSON.parse(savedTotalsmn) : [];
  });
  const [errorRows, setErrorRows] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [messageData, setMessageData] = useState({ receiptNumber: '', dueDate: '' });
  const [showToast, setShowToast] = useState(false);
  const [loadingDomiciliation, setLoadingDomiciliation] = useState({});
  const [currentErrorMessage, setCurrentErrorMessage] = useState('');

  useEffect(() => {
    if (window.location.pathname !== '/cobranza/agente') {
      localStorage.setItem('selectedTotals', JSON.stringify(selectedTotals));
    }
  }, [selectedTotals]);

  useEffect(() => {
    if (window.location.pathname !== '/cobranza/agente') {
      localStorage.setItem('selectedTotalsmn', JSON.stringify(selectedTotalsmn));
    }
  }, [selectedTotalsmn]);

  useEffect(() => {
    if (selectedData.length === 0) {
      setSelectedTotals([]);
      setSelectedTotalsmn([]);
      if (window.location.pathname !== '/cobranza/agente') {
        localStorage.setItem('selectedTotals', JSON.stringify([]));
        localStorage.setItem('selectedTotalsmn', JSON.stringify([]));
      }
    }
  }, [selectedData]);

  const domiciliationErrors = {
    'Some receipts have expired.': 'No es posible domiciliar esta póliza, debido a que tiene uno o más recibos vencidos.',
    'Some receipts with alea gestor have expired.': 'No es posible cambiar la domiciliación de esta póliza, debido a que tiene uno o más recibos vencidos'
  };

  const getDomiciliationErrorMessage = errorMessage => {
    const cleanErrorMessage = errorMessage ? String(errorMessage).trim() : '';

    if (domiciliationErrors[cleanErrorMessage]) {
      return domiciliationErrors[cleanErrorMessage];
    }

    return 'No es posible domiciliar esta póliza, debido a que tiene uno o más recibos vencidos.';
  };

  // Domiciliation error
  useEffect(() => {
    if (errorDomiciliationRequest) {
      setCurrentErrorMessage(errorDomiciliationRequest);

      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
        setCurrentErrorMessage('');
      }, 5000);
      resetDomiciliationLoading();
    }
  }, [errorDomiciliationRequest, resetDomiciliationLoading]);

  const groupedRows = groupByBankReference(rows);

  const groupedByPolicyId =
    metadata && Array.isArray(metadata)
      ? metadata.reduce((acc, policy) => {
          acc[policy.policy] = policy.invoices;
          return acc;
        }, {})
      : {};


  const hasPendingBefore = (policyId, currentInvoice, selectedIdentifiers) => {
    const invoices = groupedByPolicyId[policyId] || [];
    const currentInvoiceData = invoices.find(invoice => invoice.identifier === currentInvoice);
    if (!currentInvoiceData) {
      return false;
    }

    const currentInvoiceNumber = parseInt(currentInvoiceData.identifier, 10);
    const previousInvoices = invoices.filter(invoice => {
      const invoiceNumber = parseInt(invoice.identifier, 10);
      return invoiceNumber < currentInvoiceNumber;
    });

    if (previousInvoices.length === 0) {
      return false;
    }

    const hasReference = previousInvoices.some(invoice => invoice.reference === true);
    const hasPending = previousInvoices.some(invoice => !selectedIdentifiers.includes(invoice.identifier));

    if (hasPending) {
      return hasReference
        ? 'Existen recibos anteriores pendientes de cobro en la pantalla de Pendientes de pago Referenciado'
        : 'Existen recibos anteriores pendientes de cobro';
    }

    return false;
  };

  const handleSelectAllClick = () => {
    const anySelected = rows.some(row => selectedRows.includes(row.invoice));

    if (anySelected) {
      const invoicesToDeselect = rows.map(row => row.invoice);
      onSelect([]);
      setSelectedTotals([]);
      setSelectedTotalsmn([]);
      setErrorRows({});
      deleteselectedPaymentPending(invoicesToDeselect);
    } else {
      const selectableInvoices = [];
      const selectableTotals = [];
      const selectableTotalsmn = [];
      const errors = {};
      rows.forEach(row => {
        const currentInvoice = row.invoice;
        const message = hasPendingBefore(row.policy, currentInvoice, selectableInvoices);

        if (message) {
          errors[currentInvoice] = message;
        } else {
          selectableInvoices.push(currentInvoice);
          selectableTotals.push(row.total);
          selectableTotalsmn.push(row.totalmn);
        }
      });

      setErrorRows(errors);

      const uniqueInvoices = Array.from(new Set([...selectedRows, ...selectableInvoices]));
      onSelect(uniqueInvoices);
      setSelectedTotals(Array.isArray(selectableTotals) ? selectableTotals : []);
      setSelectedTotalsmn(Array.isArray(selectableTotalsmn) ? selectableTotalsmn : []);
      selectedPaymentPending(selectableInvoices);
    }
  };

  const handleDeleteRow = async invoiceRow => {
    setIsLoading(true);
    try {
      const row = rows.find(r => r.invoice === invoiceRow);
      const policyInvoices = groupedByPolicyId[row.policy] || [];
      const deleteFromIndex = policyInvoices.findIndex(item => item.identifier === invoiceRow);

      let invoicesToDelete = [invoiceRow];
      
      if (deleteFromIndex !== -1) {
        const subsequentInvoices = policyInvoices
          .slice(deleteFromIndex + 1)
          .map(item => item.identifier);
        invoicesToDelete = [...invoicesToDelete, ...subsequentInvoices];
      }

      await deleteselectedPaymentPending(invoicesToDelete);

      const updatedRows = rows.filter(row => !invoicesToDelete.includes(row.invoice));
      onSelect(selectedRows.filter(id => !invoicesToDelete.includes(id)));
      setSelectedTotals(selectedTotals.filter((_, i) => !invoicesToDelete.includes(rows[i].invoice)));
      setSelectedTotalsmn(selectedTotalsmn.filter((_, i) => !invoicesToDelete.includes(rows[i].invoice)));
      
      const updatedErrors = { ...errorRows };
      invoicesToDelete.forEach(invoice => {
        delete updatedErrors[invoice];
      });
      setErrorRows(updatedErrors);

      setRows(updatedRows);
    } catch (error) {
      console.error('Error deleting payment:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClick = (event, invoice, total, row) => {
    event.stopPropagation();
    
    onSelect(prevSelected => {
      let newSelected = Array.isArray(prevSelected) ? [...prevSelected] : [];
      const selectedIndex = newSelected.indexOf(invoice);
      const policyInvoices = groupedByPolicyId[row.policy] || [];
      const message = hasPendingBefore(row.policy, row.invoice, newSelected);
      if (selectedIndex === -1) {
        if (message) {
          setErrorRows(prev => ({ ...prev, [row.invoice]: message }));
          return newSelected;
        } else {
          newSelected.push(invoice);
          setErrorRows(prev => {
            const updatedErrors = { ...prev };
            delete updatedErrors[row.invoice];
            return updatedErrors;
          });
        }
      } else {
        const deselectFromIndex = policyInvoices.findIndex(item => item.identifier === invoice);

        if (deselectFromIndex !== -1) {
          const invoicesToDeselect = policyInvoices.slice(deselectFromIndex).map(item => item.identifier);

          newSelected = newSelected.filter(id => !invoicesToDeselect.includes(id));

          deleteselectedPaymentPending(invoicesToDeselect);
        }
      }

      return newSelected;
    });
  };

  const handleExpandClick = invoice => {
    setExpandedRows(prev => ({
      ...prev,
      [invoice]: !prev[invoice]
    }));
    if (onExpand) onExpand(invoice);
  };

  const isSelected = invoice => selectedRows.indexOf(invoice) !== -1;

  const isMixedCurrency =
    selectedData.some(row => row.currency === 'USD') && selectedData.some(row => row.currency === 'MXP');

  const calculatedTotalSummn = parseFloat(
    selectedData
      .filter(item => typeof item === 'object' && !isNaN(parseFloat(item.total)))
      .reduce((acc, row) => {
        const totalmn = isMixedCurrency && row.currency === 'USD' ? row.total * currency : row.total;
        return acc + parseFloat(totalmn);
      }, 0)
      .toFixed(2)
  ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const calculatedTotalSum = parseFloat(
    selectedData
      .filter(item => typeof item === 'object' && !isNaN(parseFloat(item.total)))
      .reduce((acc, row) => {
        const totalmn = isMixedCurrency && row.currency === 'USD' ? row.total * currency : row.total;
        return acc + parseFloat(totalmn);
      }, 0)
      .toFixed(2)
  ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const tokenDirection = localStorage.getItem('tokenDirection');

  //Domiciliación

  const handleDomiciliationClick = async (event, row) => {
    try {
      setLoadingDomiciliation(prev => ({ ...prev, [row.uuid]: true }));
      event.stopPropagation();
      const amount = Number(row.total.replace(/,/g, ''));
      const currencyRate = row.currency === 'USD' ? currency : 1;

      const payload = {
        receipt: {
          uuid: row.uuid,
          amount: amount,
          currency_rate: currencyRate
        },
        // Include token for backend to verify domiciliation permissions
        token: paymentToken
      };
      await recurringPaymentRequestAgent(paymentToken, payload);
    } finally {
      setLoadingDomiciliation(prev => ({ ...prev, [row.uuid]: false }));
    }
  };

  const handleCloseMessage = () => {
    setShowMessage(false);
  };

  const renderDomiciliationButton = (row) => {
    const recurringPayment = Number(row.recurring_payment);
    const hasDomiciliation = recurringPayment === 1;
    const isAleaGestor = row.gestor === "ALEA";

    if (hasDomiciliation || isAleaGestor) {
      return <ChangePaymentMethodAction 
        row={row} 
        paymentToken={paymentToken} 
        setShowCancellationMessage={setShowCancellationMessage}
      />;
    }

    return (
      <Button
        className={classes.btnSecondary}
        onClick={(e) => handleDomiciliationClick(e, row)}
        disabled={isLoading || loadingDomiciliation[row.uuid]}
      >
        {loadingDomiciliation[row.uuid] ? <Spinner /> : 'DOMICILIAR'}
      </Button>
    );
  };

  const handleDetailClick = async (row) => {
    try {
      if (!paymentToken) {
        console.error('No payment token available');
        return;
      }

      const queryParams = new URLSearchParams();
      queryParams.append('page', '1');
      queryParams.append('limit', '12');

      const response = await getPaymentReceiptHistory(paymentToken, row.uuid, queryParams.toString());
      
      if (response) {
        window.location.href = `/cobranza/movimientos/${row.uuid}`;
      }
    } catch (error) {
      console.error('Error fetching payment receipt history:', error);
    }
  };

  return (
    <React.Fragment>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div className={isMobile ? classes.tableContainersMobile : classes.tableContainers} id="tableAgent">
          <div className={classes.tableContainer}>
            <div
              className={classNames(
                type === 'pending'
                  ? isMobile
                    ? classes.headerRowMobilePending
                    : canViewDomiciliation
                    ? classes.headerRowPending
                    : classes.headerRowPendingNoDom
                  : type === 'summary'
                  ? classes.headerRowSummary
                  : isMobile
                  ? classes.headerRowMobile
                  : classes.headerRow
              )}
            >
              <div className={classes.cellHead}>
                {withCheckbox && (
                  <CustomCheckbox
                    indeterminate={selectedRows.length > 0 && selectedRows.length < rows.length}
                    checked={rows.length > 0 && selectedRows.length === rows.length}
                    onChange={handleSelectAllClick}
                    disabled={isLoading}
                  />
                )}
                <div className={classes.cellHead}>Oficina, Ramo, Póliza</div>
              </div>
              {columns.filter(item => item.key !== 'office_id').map((column, index) => (
                <div key={index} className={classes.cellHead}>
                  {column.label}
                </div>
              ))}
              {type === 'pending' && canViewDomiciliation && (
                <div className={isMobile ? classes.cellHeadMobile : classes.cellHead}>
                  Domiciliación
                </div>
              )}
              {withActions && <div className={classes.cellHead }>Acciones</div>}
            </div>

            {isLoading && (
              <div className="spinner__table-page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
                <BarLoader sizeUnit={'px'} size={24} margin={'0 10px'} color={'#1e5799'} />
              </div>
            )}

            {!isLoading &&
              rows.length === 0 &&
              (tokenDirection === 'token' || tokenDirection === undefined || tokenDirection === null) &&
              isFilter && (
                <div
                  className={classes.cellHead}
                  style={{
                    justifyContent: 'center',
                    height: '660px',
                    borderRadius: '5px 5px 0 0',
                    background: '#F5F5F5'
                  }}
                >
                  <span 
                    style={{
                      fontSize: '30px',
                      fontWeight: 600,
                      textAlign: 'center',
                      fontFamily: 'Sura Sans',
                      position: isMobile ? 'absolute' : 'relative',
                      left: isMobile ? '50%' : '0',
                      transform: isMobile ? 'translate(-50%, -50%)' : 'none' }}>
                    No se encontraron resultados
                  </span>
                </div>
              )}
            {!isLoading && rows.length === 0 && !isFilter && (
              <div
                className={classes.cellHead}
                style={{
                  justifyContent: 'center',
                  height: '660px',
                  borderRadius: '5px 5px 0 0',
                  background: '#F5F5F5',
                  flexDirection: 'column'
                }}
              >
                <img
                  src={iconEmptyCall}
                  className={isMobile ? "logoemptyagentMobile" : "logoemptyagent"}
                />
                <span
                  style={{
                    fontSize: '20px',
                    fontWeight: 600,
                    textAlign: isMobile ? 'center' : 'left',
                    fontFamily: 'Sura Sans',
                    position: isMobile ? 'absolute' : 'relative',
                    left: isMobile ? '50%' : '0',
                    transform: isMobile ? 'translateX(-50%)' : 'none'
                  }}>
                  Realiza una búsqueda o filtra de acuerdo a tus necesidades
                </span>
              </div>
            )}

            {!isLoading &&
              Object.keys(groupedRows).map((bankReference, index) => (
                <React.Fragment key={bankReference}>
                  {bankReference !== 'no_reference' && groupedRows[bankReference].some(row => row.can_use_check) && (
                    <div
                      style={{
                        display: 'flex',
                        padding: '15px 0 0 15px',
                        alignItems: 'flex-end',
                        background: '#E5E9EA',
                        width: '100%',
                        borderRadius: index === 0 ? '5px 5px 0 0' : '0'
                      }}
                    >
                      <CustomCheckbox
                        style={{ padding: 0 }}
                        onChange={e => {
                          if (e.target.checked) {
                            onSelect(prevSelected => [...new Set([...prevSelected, bankReference])]);
                          } else {
                            onSelect(prevSelected => prevSelected.filter(reference => reference !== bankReference));
                          }
                        }}
                        checked={selectedRows.includes(bankReference)}
                        disabled={isLoading}
                      />
                      <span
                        style={{
                          fontSize: '17px',
                          color: '#000000',
                          fontWeight: 600,
                          fontFamily: 'Sura Sans',
                          marginLeft: '10px'
                        }}
                      >
                        {`Referencia: ${bankReference}`}
                      </span>
                    </div>
                  )}

                  {groupedRows[bankReference].map((row, index) => {
                    const isItemSelected = isSelected(row.invoice);
                    const isExpanded = expandedRows[row.invoice] || false;
                    const [issuePart, duePart] = row.issue_date.split(' - ');

                    return (
                      <div
                        key={`${row.invoice}-${row.uuid}-${index}`}
                        style={{
                          background: '#E5E9EA',
                          padding: '5px 5px 0',
                          borderRadius: index === 0 && type !== 'referenced_payments' ? '5px 5px 0 0' : '0'
                        }}
                      >
                        <div
                          className={classNames(
                            type === 'pending'
                              ? isMobile
                                ? classes.rowMobilePending
                                : canViewDomiciliation
                                  ? isExpanded
                                    ? classes.rowPendingExpanded
                                    : classes.rowPending
                                  : isExpanded
                                    ? classes.rowPendingExpandedNoDom
                                    : classes.rowPendingNoDom
                              : type === 'summary'
                              ? classes.rowSummary
                              : isMobile
                              ? classes.rowMobile
                              : isExpanded
                              ? classes.rowExpanded
                              : classes.row,
                            errorRows[row.invoice] && classes.errorRow
                          )}
                          onClick={event => onRowClick && onRowClick(event, row.invoice, row.total)}
                        >
                          <div className={classNames(classes.cell)}>
                            {withCheckbox && (
                              <CustomCheckbox
                                checked={isItemSelected}
                                onChange={event => handleClick(event, row.invoice, row.total, row)}
                                inputProps={{ 'aria-labelledby': row.invoice }}
                                disabled={isLoading}
                              />
                            )}
                            <span
                              style={{
                                color: '#0133A0',
                                fontSize: '14px',
                                fontWeight: '600',
                                fontFamily: 'Sura Sans',
                                marginLeft: !withCheckbox ? '14px' : '0'
                              }}
                            >
                              {row.office_id} - {row.product_id} - {row.policy_id}
                            </span>
                            <IconButton onClick={() => handleExpandClick(row.invoice)}>
                              {isExpanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                            </IconButton>
                          </div>

                          {columns
                            .filter(item => item.key !== 'office_id')
                            .map((column, index) => (
                              <div key={index} className={classNames(classes.cell)}>
                                {column.key === 'issue_date' ? (
                                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ display: 'flex' }}>
                                      <span className={classes.textHead}>Ini.</span>
                                      <span style={{ whiteSpace: 'nowrap', fontWeight: 500 }}>
                                        {issuePart.slice(-10)}
                                      </span>
                                    </div>
                                    <div style={{ display: 'flex' }}>
                                      <span className={classes.textHead}>Fin.</span>
                                      <span style={{ whiteSpace: 'nowrap', fontWeight: 500 }}>
                                        {duePart.slice(-10)}
                                      </span>
                                    </div>
                                  </div>
                                ) : (
                                  row[column.key]
                                )}
                              </div>
                            ))}
                          {type === 'pending' && canViewDomiciliation && (
                            <div className={isMobile ? classes.cellMobile : classes.cell}>
                              {renderDomiciliationButton(row)}
                            </div>
                          )}
                          {withActions && (
                            <div className={classNames(classes.cell)}>
                              <IconButton onClick={() => handleDeleteRow(row.invoice)}>
                                <img src={Basurero} alt="Delete" />
                              </IconButton>
                            </div>
                          )}
                        </div>

                        {errorRows[row.invoice] && <div className={classes.errorMessage}>{errorRows[row.invoice]}</div>}

                        {isExpanded && (
                          <div
                            style={{ borderRadius: '0 0 10px 10px', borderTop: '1px solid #F4F4F4' }}
                            className={classNames(
                              type === 'pending' ? classes.expandedRowPending : classes.row,
                              classes.expandedRow
                            )}
                          >
                            {type === 'paid_unapplied' || type === 'paid_applied' ? (
                              <div className={classes.cell}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  <span className={classes.textHead}>Fecha pago</span>
                                  <span className={classes.textBold}>{row.paid_at}</span>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '10px' }}>
                                  <span className={classes.textHead}>Fecha aplicación</span>
                                  <span className={classes.textBold}>{row.application_date}</span>
                                </div>
                              </div>
                            ) : (
                              <div className={classes.cell}></div>
                            )}
                            {isPending || withActions || type === 'paid_unapplied' || type === 'paid_applied' ? (
                              <div className={classNames(classes.cell)}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  <span className={classes.textHead}>Referencia</span>
                                  <span className={classes.textBold}>
                                    {Number(row.recurring_payment) === 1 ? row.authorization_code : row.reference}
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <div className={classes.cell}></div>
                            )}
                            <div className={classes.cell}>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span className={classes.textHead}>Solución</span>
                                <span className={classes.textBold}>{row.solution}</span>
                              </div>
                            </div>
                            <div className={classes.cell}>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span className={classes.textHead}>Grupo</span>
                                <span className={classes.textBold}>{row.group_id}</span>
                              </div>
                            </div>
                            <div className={classes.cell}>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span className={classes.textHead}>Subgrupo</span>
                                <span className={classes.textBold}>{row.subgroup_id}</span>
                              </div>
                            </div>
                            {type === 'pending' && (
                              <Fragment>
                                <div className={classes.cell}>
                                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span className={classes.textHead}>Acciones</span>
                                    <button className={classes.detailButton} onClick={() => handleDetailClick(row)}>
                                      Ver detalle
                                    </button>
                                  </div>
                                </div>
                              </Fragment>
                            )}
                            {isPending ? (
                              <div className={classNames(classes.cell)}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  <span className={classes.textHead}>Estado de aplicación</span>
                                  {row.status === 'Monto menor al emitido' ? (
                                    <CustomTooltip
                                      title="Comunicate con cobranza para una aclaración. Al correo atencion.cobranza@sura.com"
                                      arrow
                                    >
                                      <span style={{ color: '#d12d35' }} className={classes.textBold}>
                                        {row.status}
                                      </span>
                                    </CustomTooltip>
                                  ) : (
                                    <span style={{ color: '#087015' }} className={classes.textBold}>
                                      {row.status}
                                    </span>
                                  )}
                                </div>
                              </div>
                            ) : (
                              <div className={classes.cell}></div>
                            )}
                            {type === 'paid_unapplied' || type === 'paid_applied' ? (
                              <div className={classes.cell}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  <span className={classes.textHead}>MSI</span>
                                  <span className={classes.textBold}>{row.interest_free_months}</span>
                                </div>
                              </div>
                            ) : (
                              <div className={classes.cell}></div>
                            )}
                            {type === 'paid_unapplied' || type === 'paid_applied' ? (
                              <div className={classes.cell}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  <span className={classes.textHead}>Medio pago</span>
                                  <span className={classes.textBold}>
                                    {Number(row.recurring_payment) === 1 ? 'Domiciliado' : row.payment_method}
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <div className={classes.cell}></div>
                            )}
                            <div className={classes.cell}></div>
                            <div className={classes.cell}></div>
                            <div className={classes.cell}></div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </React.Fragment>
              ))}
          </div>
        </div>
        {!isLoading && (
          <PaginationBar
            selectedReferences={selectedReferences}
            setOrderParams={setOrderParams}
            orderParams={orderParams}
            type={type}
            agentId={agentId}
            currentPage={currentPage}
            getDataTable={getDataTable}
            withActions={withActions}
            rows={rows}
            totalRecords={totalRecordsPending}
            totalPagesPending={totalPagesPending}
            page={page}
            selectedData={selectedData}
            currentRecords={currentRecordsPending}
            selectedRows={selectedRows}
            onPageChange={onPageChange}
            totalSum={calculatedTotalSum}
            totalSummn={calculatedTotalSummn}
            paymentToken={paymentToken}
          />
        )}
      </div>
      {showToast && (
        <div className={classes.domiciliationToast}>
          <span>{getDomiciliationErrorMessage(currentErrorMessage)}</span>
        </div>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  selectedData: get(state, 'agentReducer.selected'),
  agentId: state.agentReducer.infoAgent.cdAgente,
  paymentToken: state.agentReducer.paymentToken,
  metadata: state.agentReducer.metadata,
  currency: state.agentReducer.currency,
  isFilter: state.agentReducer.isFilter,
  errorPaymentRequest: state.agentReducer.errorPaymentRequest,
  errorDomiciliationRequest: state.agentReducer.errorDomiciliationRequest
});

const mapDispatchToProps = {
  selectedPaymentPending,
  deleteselectedPaymentPending,
  paymentRequestAgent,
  recurringPaymentRequestAgent,
  getPaymentReceiptHistory,
  resetPaymentLoading,
  resetDomiciliationLoading
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles, { withTheme: true })
)(GenericTable);



// WEBPACK FOOTER //
// ./src/containers/agent/Tabs/Payments/table/GenericTable.js